import { databases, DB_ID, COLLECTIONS, ID } from "../appwrite";
import type { Models } from "appwrite";

export interface Project {
    $id?: string;
    slug: string;
    title: string;
    category: string;
    location: string;
    scope: string;
    outcome: string;
    status: "Ongoing" | "Completed" | string;
    imageUrl: string;
}

const COL = COLLECTIONS.PROJECTS ?? "projects";

export const projectsService = {
    list: () =>
        databases
            .listDocuments(DB_ID, COL)
            .then((r) => r.documents as unknown as Array<Project & Models.Document>),

    create: (data: Omit<Project, "$id">) =>
        databases.createDocument(DB_ID, COL, ID.unique(), data),

    update: (id: string, data: Partial<Project>) => {
        const {
            $id,
            $createdAt,
            $updatedAt,
            $permissions,
            $databaseId,
            $collectionId,
            ...updateData
        } = data as any;
        return databases.updateDocument(DB_ID, COL, id, updateData);
    },

    remove: (id: string) =>
        databases.deleteDocument(DB_ID, COL, id),
};
